import { render, staticRenderFns } from "./nexmoSmsLog.vue?vue&type=template&id=54b6ae12"
import script from "./nexmoSmsLog.vue?vue&type=script&lang=js"
export * from "./nexmoSmsLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports